<template>
  <div class="self-textarea">
    <el-form-item :label="label" :prop="keyName" :label-width="labelWidth">
      <el-input
        :autosize="{ minRows: 4, maxRows: 8 }"
        type="textarea"
        v-model.trim="ruleForm[keyName]"
        @input="count"
      />
    </el-form-item>
    <div :style="{ 'padding-left': labelWidth }">
      <p v-if="surplusCount >= 0" class="self-textarea-count">
        还可以输入{{ surplusCount }}个字
      </p>
      <p v-if="surplusCount < 0" class="self-textarea-count">
        已超过<span style="color:red">{{ Math.abs(surplusCount) }}</span
        >字
      </p>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    if (this.ruleForm[this.keyName]) {
      this.count()
    }
  },
  methods: {
    count() {
      // 统计字数
      this.surplusCount = this.maxLength - this.ruleForm[this.keyName].length
    },
  },
  data() {
    return {
      surplusCount: this.maxLength,
    }
  },
  props: {
    maxLength: {
      type: Number,
    },
    ruleForm: {
      type: Object,
    },
    keyName: {
      type: String,
    },
    labelWidth: {
      type: String,
      default() {
        return '80px'
      },
    },
    label: {
      type: String,
      default() {
        return '备注'
      },
    },
  },
}
</script>
<style lang="stylus">
@import '../../assets/css/common-color.styl'
.self-textarea
  width 99%
  .self-textarea-count
    color gray03
    font-size 12px
    width calc(100% - 130px)
    margin-left 140px
    text-align right
    box-sizing border-box
    padding-right 20px
    margin-top 10px
  .el-form-item
    margin-bottom 0!important
</style>
